import { render, staticRenderFns } from "./SettingsColors.vue?vue&type=template&id=2f3c7b56&scoped=true&"
import script from "./SettingsColors.vue?vue&type=script&lang=js&"
export * from "./SettingsColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c7b56",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3c7b56')) {
      api.createRecord('2f3c7b56', component.options)
    } else {
      api.reload('2f3c7b56', component.options)
    }
    module.hot.accept("./SettingsColors.vue?vue&type=template&id=2f3c7b56&scoped=true&", function () {
      api.rerender('2f3c7b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsColors.vue"
export default component.exports